import {
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import {
    GetProductCollectionRealTimePriceApiV2Parameter,
    getProductCollectionRealTimePrices,
} from "@insite/client-framework/Services/ProductServiceV2";
import { getSettingsCollection, getShouldLoadPricing } from "@insite/client-framework/Store/Context/ContextSelectors";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import { chain, ExecuteOnErrorCallback, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing"
type Parameter = GetProductCollectionRealTimePriceApiV2Parameter &
    HasOnSuccess<RealTimePricingModel> &
    HasOnError<unknown>;

interface Props {
    apiResult: RealTimePricingModel;
    apiParameter: GetProductCollectionRealTimePriceApiV2Parameter;
    error?: unknown;
}

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiOverride: HandlerType = async props => {
    if (!getSettingsCollection(props.getState()).productSettings.canSeePrices) {
        return false;
    }

    try {
        props.apiResult = await getProductCollectionRealTimePrices(props.apiParameter);
    } catch (error) {
        if (error.status === 403) {
            // auth timed out with sign in required for pricing - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
            props.error = error;
            throw error;
        } else {
            logger.warn(`Failed to load pricing data: ${error}`);
            props.error = error;
        }
    }
};

replaceInChain(chain, ExecuteOnErrorCallback, props => {
    if (props.error) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        const productIds = props.apiParameter.productPriceParameters?.map(p => p.productId) ?? [];
        (props.dispatch as any)({ type: "Pages/ProductList/FailedLoadRealTimePricing" });
        const productDetailInfosById = (props.getState() as any).pages?.productDetails?.productInfosById;
        if (productIds.length > 0 && productDetailInfosById != null) {
            (props.dispatch as any)({ type: "Pages/ProductDetails/FailedLoadRealTimePricings", productIds });
        }
    }
});

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiOverride);
